import React from "react";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

interface ExportCSVProps {
  data: any[];
  label: string;
  filename: string;
  divStyles: string;
  buttonStyles: string;
}

export const ExportCSV: React.FC<ExportCSVProps> = ({
  data,
  filename,
  divStyles,
  buttonStyles,
  label,
}) => {
  const file = `${filename}.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const exportData = (
    e: React.FormEvent,
    jsondata: any[],
    filename: string
  ) => {
    e.preventDefault();
    const ws = XLSX.utils.json_to_sheet(jsondata);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  return (
    <div className={divStyles}>
      <button
        onClick={(e) => exportData(e, data, file)}
        className={buttonStyles}
      >
        <span>{label}</span>
      </button>
    </div>
  );
};

export default ExportCSV;
